module.exports = __webpack_public_path__ + "img/picture_viptc02.3a32d3ef.png";